var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var _a;
import * as moment from 'moment';
export var fontFamily = '"Muli", "Helvetica Neue", Helvetica, Arial, sans-serif';
export var fontStyle = 400;
var limeColor = {
    hex: '#cddc39',
    rgba: 'rgba(205, 220, 57, 0.22)'
};
var generateGradientFromRgba = function (r, g, b) {
    var canvasContext = document.createElement('canvas').getContext('2d');
    var gradient = canvasContext.createLinearGradient(0, 0, 0, 300);
    gradient.addColorStop(0, "rgba(" + r + ", " + g + ", " + b + ", 0.5)");
    gradient.addColorStop(1, "rgba(" + r + ", " + g + ", " + b + ", 0.05)");
    return gradient;
};
var ɵ0 = generateGradientFromRgba;
var greenColor = {
    hex: '#77ECC5',
    rgba: generateGradientFromRgba(119, 236, 197)
};
var nightGreenColor = {
    hex: '#21D196',
    rgba: generateGradientFromRgba(33, 209, 150)
};
var blueColor = {
    hex: '#56B0F2',
    rgba: generateGradientFromRgba(86, 176, 242)
};
var darkBlueColor = {
    hex: '#366BF3',
    rgba: generateGradientFromRgba(54, 107, 243)
};
export var availableColors;
(function (availableColors) {
    availableColors["lime"] = "lime";
    availableColors["green"] = "green";
    availableColors["nightGreen"] = "nightGreen";
    availableColors["blue"] = "blue";
    availableColors["darkBlue"] = "darkBlue";
})(availableColors || (availableColors = {}));
export var chartLineColor = (_a = {},
    _a[availableColors.lime] = generateLineChartColor(limeColor.hex, limeColor.rgba),
    _a[availableColors.green] = generateLineChartColor(greenColor.hex, greenColor.rgba),
    _a[availableColors.nightGreen] = generateLineChartColor(nightGreenColor.hex, nightGreenColor.rgba),
    _a[availableColors.blue] = generateLineChartColor(blueColor.hex, blueColor.rgba),
    _a[availableColors.darkBlue] = generateLineChartColor(darkBlueColor.hex, darkBlueColor.rgba),
    _a);
export var chartDoughnutColor = generateDoughnutChartColor([greenColor, limeColor, nightGreenColor]);
function generateLineChartColor(hex, rgba) {
    return {
        backgroundColor: rgba,
        borderColor: hex,
        pointBackgroundColor: hex,
        pointBorderColor: hex,
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: hex
    };
}
function generateDoughnutChartColor(colors) {
    var hexs = colors.map(function (el) { return el.hex; });
    var whites = colors.map(function (el) { return '#fff'; });
    return {
        backgroundColor: hexs,
        hoverBackgroundColor: hexs,
        borderColor: whites
    };
}
export var tooltips = {
    tooltips: {
        backgroundColor: '#fff',
        titleFontColor: '#c6c6c6',
        bodyFontColor: '',
        borderWidth: 0.5,
        borderColor: '#c6c6c6',
        displayColors: false,
        titleFontFamily: fontFamily,
        titleFontStyle: fontStyle,
        bodyFontFamily: fontFamily,
        bodyFontStyle: fontStyle,
        yPadding: 10,
        cornerRadius: 2,
        callbacks: {
            title: function (tooltipItem, data) {
                if (data.datasets[0].date) {
                    return moment(data.datasets[0].date[tooltipItem[0].index]).format('dddd, MMM DD, HH:mm');
                }
            }
        }
    }
};
export var defaultChartConfig = __assign({}, tooltips, { plugins: {
        datalabels: {
            // hide datalabels for all datasets
            display: false
        }
    }, responsive: true, maintainAspectRatio: false, legend: {
        onClick: function (e) {
            e.stopPropagation();
        }
    }, layout: {
        padding: {
            top: 16,
            right: 0,
            left: 0,
            bottom: 0
        }
    } });
export { ɵ0 };
